// CREATE:
// src/components/blog/ArticleMeta.jsx

import React from "react";
import useThemeMode from "../../hooks/useThemeMode";
import { getMarketingTheme } from "../../utils/marketingTheme";

function ArticleMeta({
  author,
  publishDate,
  readTime,
  category
}) {
  const { isDark } = useThemeMode();
  const colors = getMarketingTheme(isDark);

  return (
    <section
      style={{
        padding: "0 20px 24px"
      }}
    >
      <div
        style={{
          maxWidth: "1000px",
          margin: "0 auto",
          display: "flex",
          flexWrap: "wrap",
          gap: "12px",
          alignItems: "center",
          color: colors.textMuted,
          fontSize: "14px"
        }}
      >
        <MetaPill colors={colors}>
          {author}
        </MetaPill>

        <MetaPill colors={colors}>
          {publishDate}
        </MetaPill>

        <MetaPill colors={colors}>
          {readTime}
        </MetaPill>

        <MetaPill colors={colors}>
          {category}
        </MetaPill>
      </div>
    </section>
  );
}

function MetaPill({ children, colors }) {
  return (
    <div
      style={{
        padding: "8px 14px",
        borderRadius: "999px",
        background: colors.cardBg,
        border: `1px solid ${colors.border}`
      }}
    >
      {children}
    </div>
  );
}

export default ArticleMeta;